import { Expose } from "class-transformer";

export class ExternalUrlSession {
  @Expose()
  id!: string;

  @Expose()
  url!: string;
}
